import React from 'react'
import { Modal } from 'react-bootstrap'
import { t } from 'ttag'
import { useHistory } from 'react-router-dom'

import HubSpotForm from '../form/HubSpotForm'

const LibraryRequestDemoForm = () => {
  const history = useHistory()
  const onCancel = () => {
    history.push('/')
  }

  return (
    <Modal show={true} bsSize="lg" onHide={onCancel} dialogClassName="fullscreen-modal">
      <Modal.Body style={{ padding: 0 }}>
        <div className="row" style={{ display: 'flex' }}>
          <div
            className="left-modal-col"
            style={{
              minHeight: '80vh',
              float: 'left',
              width: '30%',
              padding: '25px',
              backgroundColor: '#6a3460'
            }}>
            <h2 style={{ color: 'white', fontWeight: '300', marginBottom: '25px' }}>
              Request a Demo Account
            </h2>
            <p style={{ color: 'white' }}>
              Please fill out the form, and we'll be happy to send you demo credentials so
              you can take a look around.
            </p>
          </div>
          <div
            className="right-modal-col section"
            style={{
              minHeight: '80vh',
              float: 'left',
              width: '70%',
              padding: '25px 15px',
              backgroundColor: '#fff'
            }}>
            <button
              type="button"
              className="close"
              aria-label={t`Close`}
              onClick={onCancel}>
              <span aria-hidden="true" style={{ fontSize: '2rem' }}>
                ×
              </span>
            </button>

            <HubSpotForm
              formId="f97bafeb-b9e6-4b3e-b62d-8b94ccb4a3e0"
              onSubmit={() => {
                history.push('/requestdemo/confirmation')
              }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export { LibraryRequestDemoForm }
